import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetSurveyWithinTimeframe = 'GET_SURVEYS_WITHIN_TIMEFRAME';

export const useGetSurveysWithinTimeframe = (
  fromDate: string,
  toDate: string,
  teamId: number,
  enabled: boolean = true,
) => {
  const { fetchSurveysWithinTimeframe } = useServicesContext();

  return useQuery({
    queryKey: [GetSurveyWithinTimeframe, fromDate, toDate, teamId],
    queryFn: () => fetchSurveysWithinTimeframe(teamId!, fromDate, toDate),
    refetchInterval: 60000,
    enabled: enabled && Boolean(teamId),
  });
};
